import {
  Button,
  Layout,
  theme,
  Form,
  Input,
  Spin,
  Select,
  notification,
} from "antd";

import React, { useState } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import TextArea from "antd/es/input/TextArea";
import ShelfLifeApi from "../../common/Apis/ShelfLifeApi";

const AddOpenShelfLife = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [loadings, setLoadings] = useState(false);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSubmit = (data) => {
    let formData = JSON.stringify({
      period: data?.period,
      periodType: data?.periodType,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    })

    ShelfLifeApi.CreateShelfLife(formData)
      .then((response) => {
        setLoadings(false);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
          description: "Create Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/masters/shelf-life");
      })
      .catch((err) => {
        if (err.apiError.status) {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  const validateInputNumber = (_, value) => {
    if (value >= 0) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Value must be greater than to 0"));
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="period"
                    label="Period"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Period",
                      },
                      { validator: validateInputNumber },
                    ]}
                  >
                    <Input
                      type="number"
                      min={0}
                      placeholder="Period"
                      className="control-input"
                    />
                  </Form.Item>
                  <p style={{ color: "#3D54A4" }}>Period should be entered as a number. Ex : 1, 2, 3, 4</p>
                </Col>

                <Col lg={8} md={12}>
                  <Form.Item
                    name="periodType"
                    label="Period Type"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Period Type",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select"
                      placeholder="Select Period Type"
                    >
                      <option value={"DAYS"}>Days</option>
                      <option value={"WEEKS"}>Weeks</option>
                      <option value={"MONTHS"}>Months</option>
                      <option value={"YEARS"}>Years</option>
                    </Select>
                  </Form.Item>
                </Col>


              </Row>

              {/* <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Create {loadings == true && <Spin className="px-2" />}
                </Button>
              </div> */}
              <div
                className="d-flex justify-content-between pt-5"
                style={{
                  gap: "10px",

                }}
              >
                <Button
                  onClick={handleGoBack}
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#000",
                    textDecoration: "none",
                    fontWeight: 500,
                  }}
                >
                  Back
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                    fontWeight: 500,
                  }}
                >
                  Save & Continue {loadings && <Spin size="small" className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default AddOpenShelfLife;
